import { Voucher_Source_Type, Voucher_State } from '@occc/graphql';
import config from '@occc/config';

import {
  CreatedAtSelectOption,
  DateRange,
  ExpireAtSelectOption,
  SourceTypeSelectOption,
  StateSelectOption,
} from './types';

export const titleBySourceType: Record<Voucher_Source_Type, string> = {
  [Voucher_Source_Type.LoyaltyEvent]: 'Loyalty Event',
  [Voucher_Source_Type.Offer]: 'Offer',
  [Voucher_Source_Type.OfferPurchase]: 'Offer Purchase',
  [Voucher_Source_Type.Transaction]: 'Transaction',
  [Voucher_Source_Type.GameSession]: 'Game Session',
  [Voucher_Source_Type.PromocodeUseRequest]: 'Promo Code Offer',
};

// In schema voucher.sourceType is expected/should be Voucher_Source_Type
// But right now this is optional String with values like 'Offer', 'GameSession', 'PromocodeUseRequest'
// Slack thread is here: https://stuzo.slack.com/archives/C04MQ3A2WS3/p1738924607587749
export const titleBySourceTypeValue: Record<string, string> = {
  LoyaltyEvent: 'Loyalty Event',
  Offer: 'Offer',
  OfferPurchase: 'Offer Purchase',
  Transaction: 'Transaction',
  GameSession: 'Game Session',
  PromocodeUseRequest: 'Promo Code Offer',
};

export const titleByState: Record<Voucher_State, string> = {
  [Voucher_State.Unfulfilled]: 'Unfilfilled',
  [Voucher_State.Abandoned]: 'Abandoned',
  [Voucher_State.Expired]: 'Expired',
  [Voucher_State.Fulfilled]: 'Fulfilled',
};

export const titleByDateRange: Record<DateRange, string> = {
  [DateRange.Last1H]: 'Last hour',
  [DateRange.Last6H]: 'Last 6 hours',
  [DateRange.Last24H]: 'Last 24 hours',
  [DateRange.Prev24H]: 'Previous 24 hours',
  [DateRange.Custom]: 'Custom Range',
};

export const sourceTypeFilterOptions: SourceTypeSelectOption[] = [
  {
    label: 'All',
    value: 'any',
  },
  {
    label: titleBySourceType[Voucher_Source_Type.Transaction],
    value: Voucher_Source_Type.Transaction,
  },
  {
    label: titleBySourceType[Voucher_Source_Type.OfferPurchase],
    value: Voucher_Source_Type.OfferPurchase,
  },
  {
    label: titleBySourceType[Voucher_Source_Type.Offer],
    value: Voucher_Source_Type.Offer,
  },
  {
    label: titleBySourceType[Voucher_Source_Type.LoyaltyEvent],
    value: Voucher_Source_Type.LoyaltyEvent,
  },
];

if (config.features.promocodesOffersEnabled) {
  sourceTypeFilterOptions.push({
    label: 'Promo Code',
    value: Voucher_Source_Type.PromocodeUseRequest,
  });
}

export const stateFilterOptions: StateSelectOption[] = [
  {
    label: 'All',
    value: 'any',
  },
  {
    label: titleByState[Voucher_State.Fulfilled],
    value: Voucher_State.Fulfilled,
  },
  {
    label: titleByState[Voucher_State.Unfulfilled],
    value: Voucher_State.Unfulfilled,
  },
  {
    label: titleByState[Voucher_State.Expired],
    value: Voucher_State.Expired,
  },
  {
    label: titleByState[Voucher_State.Abandoned],
    value: Voucher_State.Abandoned,
  },
];

export const createdAtFilterOptions: CreatedAtSelectOption[] = [
  { label: 'All', value: 'any' },
  { label: titleByDateRange[DateRange.Last1H], value: DateRange.Last1H },
  { label: titleByDateRange[DateRange.Last6H], value: DateRange.Last6H },
  { label: titleByDateRange[DateRange.Last24H], value: DateRange.Last24H },
  { label: titleByDateRange[DateRange.Prev24H], value: DateRange.Prev24H },
  { label: titleByDateRange[DateRange.Custom], value: DateRange.Custom },
];

export const expireAtFilterOptions: ExpireAtSelectOption[] = [
  { label: 'All', value: 'any' },
  { label: titleByDateRange[DateRange.Last1H], value: DateRange.Last1H },
  { label: titleByDateRange[DateRange.Last6H], value: DateRange.Last6H },
  { label: titleByDateRange[DateRange.Last24H], value: DateRange.Last24H },
  { label: titleByDateRange[DateRange.Prev24H], value: DateRange.Prev24H },
  { label: titleByDateRange[DateRange.Custom], value: DateRange.Custom },
];
